/**
 * Query parameter names used in the funnel → brand-app handoff URL.
 *
 * The handoff URL has up to three independent parameters, each consumed by
 * the brand app for a separate concern. Keeping them as typed constants
 * here (rather than string literals at every call site) means a rename is
 * a one-line change, and we can grep usage easily across both repos.
 *
 * See docs/PLAN_SATELLITE_AUTH.md §6 for the full contract.
 *
 * | Param   | Purpose                                | Format              |
 * | ------- | -------------------------------------- | ------------------- |
 * | `ad_h`  | Attribution envelope (existing)        | Signed base64 JSON  |
 * | `au_h`  | Auth handoff signal (this module)      | `"1"` flag          |
 * | `ob_h`  | Onboarding/survey results (planned)    | Signed JSON blob    |
 *
 * The brand app's mount-time consumer:
 *   1. If `au_h=1` and `!isAuthenticated`, call `login({ prompt: "none" })`.
 *      The Kinde session cookie at `auth.<brand>.ai` (set by the funnel's
 *      register/login redirect) authorizes the silent token exchange.
 *   2. After consuming, strip the param via `history.replaceState` so the
 *      address bar stays clean.
 */

export const AUTH_HANDOFF_PARAM = "au_h";

/**
 * Sentinel value for {@link AUTH_HANDOFF_PARAM}. We use a versioned literal
 * (`"1"`) rather than a boolean-as-string so future iterations can carry
 * structured payloads (e.g. `"login_hint:user@example.com"`) without
 * breaking consumers that only check for presence.
 */
export const AUTH_HANDOFF_VALUE = "1";
